import { Helmet } from "react-helmet";

function SEOHelmet() {
  return (
    <Helmet>
      <title>Oguntoyinbo Taiwo | Full-Stack Web Developer in Lagos, Nigeria</title>
      <meta
        name="description"
        content="Oguntoyinbo Taiwo - Full-Stack Developer in Lagos, Nigeria. Offering web development, mobile app development, and software engineering services. Dedicated to delivering innovative tech solutions to help businesses grow."
      />
      <meta
        name="keywords"
        content="Oguntoyinbo Taiwo, Oguntoyinbo Taiwo Kolawole, Full-Stack Web Developer,Web Developer in Lagos, Best Web Developer in Lagos, Best Web Developer in Nigeria, Web Developer in Lagos, Mobile App Developer, Lagos Software Engineer, React Developer Nigeria, Node.js Developer, JavaScript Developer, Lagos Full Stack Developer, Software Development Nigeria, Frontend Developer, Backend Developer, Digital Solutions Lagos, E-commerce Developer, Website Developer Nigeria, Tech Expert Lagos, IT Solutions Lagos, Nigerian Web Developer, Reactjs developer, firebase developer, nigeria developer, website developer website developer in lagos"
      />
      <meta name="author" content="Oguntoyinbo Taiwo" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta property="og:title" content="Oguntoyinbo Taiwo | Full-Stack Developer in Lagos, Nigeria" />
      <meta
        property="og:description"
        content="Experienced Full-Stack Developer offering high-quality web and mobile development solutions in Lagos, Nigeria. Specializing in React, Node.js, and e-commerce solutions."
      />
      <meta property="og:url" content="https://oguntoyinbo.multibranddigital.com" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://oguntoyinbo.multibranddigital.com/image/profile.jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Oguntoyinbo Taiwo | Full-Stack Developer in Lagos, Nigeria" />
      <meta
        name="twitter:description"
        content="Top-rated Full-Stack Developer in Lagos, Nigeria. Specializing in web development, mobile apps, and tech solutions to elevate your business."
      />
      <meta name="twitter:image" content="https://oguntoyinbo.multibranddigital.com/image/profile.jpeg" />
    </Helmet>
  );
}

export default SEOHelmet;
